import { gql, useMutation } from '@apollo/client'

export const GLOBALIZE_PROJECT = gql`
  mutation ($id: String!) {
    globalizeCampaign(id: $id) {
      id
      parent {
        id
      }
      original_campaign_id
      global_status
      __typename
    }
  }
`

export const useGlobalize = () => {
  const [mutate, { data, loading, error }] = useMutation(GLOBALIZE_PROJECT, {})

  return { mutate, data, loading, error }
}
